import jQuery from "jquery";
import Constants from "../Constants";
import CW from "../services/CW";

export default  (() => {    

    return {
        exactTargetEmailMarker: "EMAIL__",
        exactTargetEmailSubjectMarker: "__subject",
        exactTargetEmailHtmlTextMarker: "__html",
        exactTargetEmailAltTextMarker: "__text",
        tokenDefaultMarker: ":default=",
	    tagBody: '(?:[^"\'>]|"[^"]*"|\'[^\']*\')*',
		tokenizeSegmentContent: function(content, projectContentType) {
            var icu = this;
		    if(this.tagOrComment == null) {
		        // Regex from here:  http://stackoverflow.com/questions/295566/sanitize-rewrite-html-on-the-client-side
                this.tagOrComment = new RegExp('(<(?:' + '!--(?:(?:-*[^->])*--+|-?)' + '|script\\b' + this.tagBody +
                   '>[\\s\\S]*?</script\\s*' + '|style\\b' + this.tagBody + '>[\\s\\S]*?</style\\s*' + '|/?[a-z]' + this.tagBody + ')>)', 'gi');
		    }
		    if(this.tagMatcher == null) {
                this.tagMatcher = new RegExp('<([^>]+)>');
		    }
            var results = [];
            // we need to keep track of the last snippet to know if we have multiple tags in a row
            var lastSnippet;
            var priorTagCount = 0;

            CW.crossBrowserRegexSplit(content, this.tagOrComment).forEach(function(snippet, posit) {
                var tokenizedSnippet = [];
                var tokenizedSnippetForEloqua = [];
                if((projectContentType == "MARKETO") || (projectContentType == "ELOQUA") || (projectContentType == "EXACTTARGET")) {
                    var regex;
                    var startDelimiter;
                    var endDelimiter;
                    var startReplace = "";
                    if(projectContentType == "MARKETO") {
                        regex = /(?={{)(.*?)}}/gi;
                        startDelimiter = "{{";
                        startReplace = "";
                        endDelimiter = "}}";
                    } else if (projectContentType == "ELOQUA") {
                        //enabling support for field merge and/or dynamic content in subject line of email
                        var regexForFieldMerge = Constants.FIELD_MERGE_REGEX;
                        var regexForDynamicContent = Constants.DYNAMIC_CONTENT_REGEX;
                        var snippetsSeparatedByFieldMerge = snippet.split(regexForFieldMerge);                        
                        snippetsSeparatedByFieldMerge.forEach(function (tSnippetSegment) {
                            if(tSnippetSegment.includes(Constants.DYNAMIC_CONTENT_START_DELIMITER)) {
                                var snippetsSeparatedByDynamicContent = tSnippetSegment.split(regexForDynamicContent);
                                if(snippetsSeparatedByDynamicContent.length > 1) {
                                    tokenizedSnippetForEloqua = icu.fetchTokenizedSnippetsForDynamicContent(snippetsSeparatedByDynamicContent, tokenizedSnippetForEloqua);
                                }
                            } else {
                                if(snippetsSeparatedByFieldMerge.length > 1) {
                                    var isToken = false;
                                    if (tSnippetSegment.indexOf(Constants.UNDERSCORE_DELIMITER) === 0) {
                                        isToken = true;
                                        tSnippetSegment = Constants.FIELD_MERGE_START_DELIMITER + tSnippetSegment + Constants.FIELD_MERGE_END_DELIMITER;
                                    }
                                    if (tSnippetSegment.length > 0) {
                                        tokenizedSnippetForEloqua.push({
                                            text: tSnippetSegment,
                                            isToken: isToken
                                        })
                                    }
                                }
                            }
                        });
                    } else if (projectContentType == "EXACTTARGET") {
                        regex = /(%%.*?%%)/gi;
                        startDelimiter = "%%";
                        startReplace = "";
                        endDelimiter = "%%";
                    }
                    var tSnippet = snippet.split(regex);
                    if(tSnippet.length > 1) {
                        tSnippet.forEach(function(snippetSegment) {
                            var isToken = false;
                            if(snippetSegment.indexOf(startDelimiter) == 0) {
                                isToken = true;
                                snippetSegment = startReplace + snippetSegment + endDelimiter;
                            }
                            if(snippetSegment && snippetSegment.length > 0) {
                                tokenizedSnippet.push({
                                    text: snippetSegment,
                                    isToken: isToken
                                });
                            }
                        });
                    }
                }

                if((snippet != null) && (snippet.length > 0)) {
                	// If several tags happen in a row, we don't want to show them all, because it's usually something like the end of one tag and the start of another
                	// So we'll keep track of how many tags in a row we've seen
                	var isPreviousElementTag = (lastSnippet != null) ? (lastSnippet.isTag) : false;
                	if(!isPreviousElementTag) {
                		priorTagCount = 0;
                	} else {
						priorTagCount++;
                	}

                	var finalTokenizedSnippet = [];
                	if(tokenizedSnippetForEloqua!=="") {
                	    finalTokenizedSnippet = tokenizedSnippetForEloqua;
                    } else {
                        finalTokenizedSnippet = (tokenizedSnippet.length > 0) ? tokenizedSnippet : null;
                    }

                    var result = {
                        text: snippet,
                        emptyText: (!snippet.trim()),
                        tokenizedSnippet: finalTokenizedSnippet,
                        isTag: icu.tagMatcher.test(snippet),
                        priorTagCount: priorTagCount,
                        projectContentType: projectContentType
                    };

                    results.push(result);
                    lastSnippet = result;
                }
            });

            return results;
		},
        fetchTokenizedSnippetsForDynamicContent : function(tSnippet, tokenizedSnippetForEloqua) {
            tSnippet.forEach(tSnippet, function (tSnippetSegment) {
                var isToken = false;
                if(tSnippetSegment.indexOf(Constants.UNDERSCORE_DELIMITER) == 0) {
                    isToken = true;
                    tSnippetSegment = Constants.DYNAMIC_CONTENT_START_DELIMITER + tSnippetSegment + Constants.DYNAMIC_CONTENT_END_DELIMITER;

                }
                if(tSnippetSegment.length > 0) {
                    tokenizedSnippetForEloqua.push({
                        text: tSnippetSegment,
                        isToken: isToken
                    })
                }
            });
            return tokenizedSnippetForEloqua;
        },
		
		annotateExactTargetSegment: function(segment) {
    		if (segment.resname.indexOf(this.exactTargetEmailMarker) == 0) {
                 if (segment.resname.indexOf(this.exactTargetEmailSubjectMarker, segment.resname.length - this.exactTargetEmailSubjectMarker.length) !== -1) {
                    segment.isSubject = true;
                 } else if (segment.resname.indexOf(this.exactTargetEmailHtmlTextMarker, segment.resname.length - this.exactTargetEmailHtmlTextMarker.length) !== -1) {
                    segment.isHtmlText = true;
                 } else if (segment.resname.indexOf(this.exactTargetEmailAltTextMarker, segment.resname.length - this.exactTargetEmailAltTextMarker.length) !== -1) {
                    segment.isAltText = true;
                 }
             }
		},
    rebuildTranslationContent: function(translation) {
		    // When a user edits a translation, the tokenizedText array gets updated. This will update the other text fields
		    // in the translation based on that            
		    var newText = "";
		    var newRawText = "";
		    translation.forEach(translation.tokenizedText, function(snippet) {
		        if(snippet.tokenizedSnippet) {
		            snippet.tokenizedSnippet.forEach(function(subSnippet) {
                      newRawText = newRawText + subSnippet.text;
                      newText = newText + subSnippet.text;
		            });
		        } else {
                    newRawText = newRawText + snippet.text;
                    if(!snippet.isTag) {
                        newText = newText + snippet.text;
                    }
		        }
		    });

		    translation.text = newText;
            translation.rawText = newRawText;
		},
		rebuildTextFromTokenizedSnippet: function(tokenizedSnippet) {
		    var icu = this;
		    var result = "";

		    tokenizedSnippet.forEach(function(subSnippet) {

		        if(subSnippet.isToken) {
		            var defaultIndex = subSnippet.text.indexOf(icu.tokenDefaultMarker);
		            if(defaultIndex > 0) {
                        result += subSnippet.text.substring((defaultIndex + icu.tokenDefaultMarker.length), (subSnippet.text.length - 2));
		            } else {
                        result += "";
		            }
		        } else {
                    result += subSnippet.text;
		        }
		    });
		    return result;
		},
		rebuildTextForAllTokenizedSnippets: function(tokenizedText) {
		    var icu = this;
		    tokenizedText.forEach( function(snippet) {
                if(snippet.tokenizedSnippet && (snippet.tokenizedSnippet.length > 0)) {
                    snippet.text = icu.rebuildTextFromTokenizedSnippet(snippet.tokenizedSnippet);
                }
		    });
		},
		encodeContentEditableText: function(inputText, isToken) {
	        if (isToken) {
	            return inputText;
            }
			return inputText.replace(/(\r\n|\n|\r)/gm," ").encodeHTML() || " ";
		},
		doesBrowserRequireManualInContextWheelSupport: function() {
		    // When you use the mouse wheel in Chrome or Safari over the iframe, that event gets propagated up to the enclosing div
		    // and scrolls properly. In firefox and IE, these events stay in the iframe, so we need to handle them manually.
		    return jQuery.browser.msie || jQuery.browser.mozilla;
		},
		doesBrowserRequireBrowserScrollbars: function () {
		    // perfectscrollbar chokes when trying to set scrollTop on a div in IE9. I have no idea why, that method usually works fine
		    // in IE9. So we need this method to let us know to use the browser scrollbars in this case...
		    return ((jQuery.browser.msie) && (parseInt(jQuery.browser.version) <= 9));
		}
    }
})();